import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import PDFDownload from "../SvgIcons/Pdf";
import Swal from "sweetalert2";

import { formatCountryDate } from "../../Services/countryTime";
export default function PdfDownloadButton({ data = [] }) {
  // ------------------- Format Date -------------------
  function formatDate(dateStr) {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;
    return formatCountryDate(d).replace(/\//g, "-");
  }

  // ------------------- Format Time -------------------
  function formatTime(timeStr) {
    if (!timeStr) return "";
    const [hour, minute] = timeStr.split(":");
    const date = new Date();
    date.setHours(hour, minute);
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true });
  }

  const handleDownloadPdf = () => {
    try {
      if (!data || !data.length) {
        Swal.fire({
          icon: "warning",
          title: "Notice",
          text: "No data available to download.",
        });
        return;
      }

      // ------------------- Group data by Title + Date + Time -------------------
      const grouped = data.reduce((acc, item) => {
        const groupKey = `${item.Title} - ${formatDate(item.event_date)} - (${formatTime(item.StartTime)} to ${formatTime(item.EndTime)})`;
        if (!acc[groupKey]) acc[groupKey] = [];
        acc[groupKey].push(item);
        return acc;
      }, {});

      const doc = new jsPDF({ orientation: "landscape" });
      const pageWidth = doc.internal.pageSize.width;

      // ------------------- Title -------------------
      const title = "Event Registrations";
      doc.setFontSize(14);
      doc.setTextColor(255, 255, 255);
      doc.setFillColor(56, 89, 142); // dark blue background
      doc.rect(0, 5, pageWidth, 10, "F"); // full-width background
      doc.text(title, pageWidth / 2, 12, { align: "center" });

      let startY = 25;

      // ------------------- Loop through each event group -------------------
      Object.entries(grouped).forEach(([eventTitle, records]) => {
        // Event Title Row (light blue)      
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 0);
        doc.setFont("helvetica", "bold"); // bold
        doc.setFillColor(204, 229, 255); // light blue
        doc.rect(10, startY - 6, pageWidth - 20, 10, "F");
        doc.text(eventTitle, pageWidth / 2, startY, { align: "center" });
        startY += 5;

        // Table headers
        const tableHeaders = [
          [
            "Sr.No.",
            "Name",
            "Email",
            "Mobile No.",
            "Organization Name",
            "Tally Number",
            "Confirmation By",
            "Participants",
            "Registration Date",
            "Mode of Meeting",
          ],
        ];

        // Table body
        const tableData = records.map((item, index) => [
          index + 1,
          item.name || "-",
          item.email || "-",
          item.mobile || "-",
          item.organization || "-",
          item.tallynumber || "-",
          item.confirmation || "-",
          item.NoOfParticipants || "-",
          formatDate(item.registration_date) || "-",
          item.ModeOfMeeting || "-",
        ]);

        // AutoTable
      autoTable(doc, {
        startY: startY + 5,
        head: tableHeaders,
        body: tableData,
        theme: "grid",
        tableWidth: "auto",
        margin: { left: 10, right: 10 },
        headStyles: {
          fillColor: [229, 235, 245],
          textColor: [0, 0, 0],
          valign: "middle",
          fontSize: 7,
        },
        bodyStyles: {
          fontSize: 7,
          valign: "middle",
        },
        columnStyles: {
          0: { halign: "center" }, // Sr.No
          1: { halign: "left" },   // Name -> left
          2: { halign: "left" },   // Email -> left
          3: { halign: "center" }, // Mobile
          4: { halign: "left" },   // Organization -> left
          5: { halign: "center" }, // Tally Number
          6: { halign: "left" },   // Confirmation By -> left
          7: { halign: "center" }, // Participants
          8: { halign: "center" }, // Registration Date
          9: { halign: "center" }, // Mode of Meeting
        },
      });

        // Update startY for next group
        startY = doc.lastAutoTable.finalY + 10;
      });

      doc.save("Event_Registrations.pdf");
    } catch (error) {
      console.error("Error while generating PDF:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to download PDF.",
      });
    }
  };

  return (
    <button type="button" className="btn btn-purpal addbutton" onClick={handleDownloadPdf}>
      <PDFDownload /> Pdf
    </button>
  );
}
